import { PayableInboxValidity } from "@/Common/Models/UI/Enums";

class PayableInboxValidityUIModel {
    constructor(payableInboxValidity: PayableInboxValidity) {
        this.validity = payableInboxValidity;
        this.label = cacheStore.GetString(`${PayableInboxValidity[payableInboxValidity]}Label`);
    }

    public label: string;
    public validity: PayableInboxValidity;
}

export { PayableInboxValidityUIModel };
